// src/hooks/useAuth.js
// Thin wrapper — all auth state lives in AuthContext (singleton).
// Every existing `import { useAuth } from '../../hooks/useAuth'` continues to work.
import { useAuthContext } from '../contexts/AuthContext';

export function useAuth() {
  return useAuthContext();
}
